import classNames from 'classnames/bind';
import React, { ReactNode } from 'react';
import Checkbox, { Shape } from './Checkbox';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IOption {
  clickCode?: string;
  label: ReactNode;
  value: any;
  naverPaySaving?: number;
}

interface IProps {
  checked: Set<any>;
  commonClickCode?: string;
  options: IOption[];
  shape: Shape;
  onChange: (value?: any) => void;
}

export default function CheckboxGroup({
  checked,
  commonClickCode = '',
  options,
  shape,
  onChange,
}: IProps) {
  return (
    <>
      {options.map(({ clickCode, label, value, naverPaySaving }, i) => (
        <Checkbox
          key={value + i}
          className={cx('CheckboxGroup_item')}
          isChecked={checked.has(value)}
          shape={shape}
          clickCode={clickCode || commonClickCode}
          onChange={() => onChange(value)}
        >
          <span className={cx('text')}>
            <span className={cx('name')}>{label}</span>
            {!!naverPaySaving && (
              <i className={cx('label_npay')}>{naverPaySaving}% 적립</i>
            )}
          </span>
        </Checkbox>
      ))}
    </>
  );
}
